import { Pipe, PipeTransform } from "@angular/core";
import { SelectItem } from "primeng/api";

@Pipe({
    name: 'mapToLabel'
})
export class MapToPLabelipe implements PipeTransform {
    constructor() {

    }

    transform(value: Number, items: SelectItem[]): string {
        if (!value || !items) {
            return "--";
        }

        let item = items.find(e => e.value === value);
        
        return !!item ? item.label : "--";
    }
}